import PageHeader from 'components/common/PageHeader';
import { MercadoLibre } from './components/MercadoLibre';

const MercadoLibrePage = () => {
  return (
    <>
      <PageHeader
        title="Mercado Libre"
        description="En esta sección puede gestionar sus publicaciones de Mercado Libre."
        className="mb-3 bg-white"
      />

      <MercadoLibre />
    </>
  );
};

export default MercadoLibrePage;
